/* global Mibew */
/* Lauch onlinechat (Mibew) once all is loaded */

const COOKIE_PREFIX = 'mibew-chat-frame-minified-'

function collectOptions() {
    const html =  document.getElementsByTagName('html')[0]
    const options = {
        'lang': html.lang === 'cs' ? 'cs' : 'en',
    }

    // Get params from element META
    for (const node of document.querySelectorAll('meta[name^="cznic:chat:"]')) {
        // Available parameters:
        //     style: mojeid
        //     buttonStyle: mojeid
        //     domain: //onlinechat.nic.cz
        //     id: 59e4cd8c98eefc65  (5aa2779a6ba95e38 on test)
        //     extraUrlPath: /index.php
        options[node.name.split(':').pop()] = node.content
    }

    // set mibew options
    const extraPath = options.extraUrlPath || ''
    options.url = options.domain + extraPath + '/chat?locale=' + options.lang + '&style=' + options.style
    options.styleLoader = options.domain + extraPath + '/chat/style/popup/' + options.style
    return options
}

function updateMibew() {
    // This function overwrites the code from
    // https://github.com/Mibew/mibew/blob/v3.5.4/src/mibew/js/source/chat_popup.js#L428
    // The difference is only that code of block `if (this.cookiesBlocked) {}` is disabled.
    Mibew.ChatPopup.IFrame.prototype.open = function(url) {
        if (this.isOpened) {
            // Do not open the popup twice.
            return
        }

        // if (this.cookiesBlocked) {
        //     // Last resort. Replace this iframe-based popup with window-based popup
        //     // and try to open a chat in a separate window.
        //     Mibew.Objects.ChatPopups[this.id] = new Mibew.ChatPopup.Window(this.options)
        //     Mibew.Objects.ChatPopups[this.id].open(url)
        //     return
        // }

        if (!this.wrapperDiv) {
            // Create new iframe and its wrapper.
            // There is a bug in IE <= 7 that make "name" attribute unchangeble
            // for elements that already exist. Thus a temporary div is used
            // here as a workaround.
            this.wrapperDiv = document.createElement('div')
            this.wrapperDiv.className = 'mibew-chat-wrapper'
            this.wrapperDiv.setAttribute('id', 'mibew-chat-wrapper-' + this.id)
            this.wrapperDiv.style.display = 'none'
            this.wrapperDiv.innerHTML = '<iframe name="mibewChat' + this.id + '"></iframe>'

            this.iframe = this.wrapperDiv.getElementsByTagName('iframe')[0]
            this.iframe.setAttribute('id', 'mibew-chat-frame-' + this.id)
            this.iframe.className = 'mibew-chat-frame'
            this.iframe.setAttribute('frameBorder', 0)

            document.getElementsByTagName('body')[0].appendChild(this.wrapperDiv)

            // Setup toggle element. As it's not a part of the iframe, it should be
            // treated separately.
            this.toggleDiv = document.createElement('div')
            this.toggleDiv.setAttribute('id', 'mibew-chat-frame-toggle-' + this.id)
            this.toggleDiv.className = 'mibew-chat-frame-toggle mibew-chat-frame-toggle-on'
            Mibew.Utils.addEventListener(this.toggleDiv, 'click', function() {
                const popups = Mibew.Objects.ChatPopups,
                    matches = /^mibew-chat-frame-toggle-([0-9A-Za-z]+)$/.exec(this.id)

                if (matches && popups[matches[1]]) {
                    popups[matches[1]].toggle()
                }
            })
            document.getElementsByTagName('body')[0].appendChild(this.toggleDiv)
        }

        this.wrapperDiv.style.display = 'block'
        this.toggleDiv.style.display = 'block'
        this.iframe.src = url || this.buildChatUrl()
        this.isOpened = true

        // Store style name in case we need it during iframe reopening
        Mibew.Utils.createCookie('mibew-chat-frame-style-' + this.id, this.styleName)

        // Check minification status of the popup and toggle it if needed.
        const minifiedPopup = Mibew.Utils.readCookie(COOKIE_PREFIX + this.id)
        if (minifiedPopup === 'true') {
            this.toggle()
        }
    }
}

function initChatPopup(options) {
    Mibew.ChatPopup.init({
        'id': options.id,
        'url': options.url,
        'preferIFrame': true,
        'modSecurity': false,
        'height': 480,
        'width': 640,
        'resizable': true,
        'style': options.style,
        'styleLoader': options.styleLoader,
    })
}

function initMibewChatAndCreateButton(node, options) {
    /* create button and append it to the onlinechat span */
    const button = document.createElement('span')
    button.classList.add("mibew-agent-button")
    button.dataset.chat_id = options.id

    const imageButton = document.createElement('img')
    imageButton.src = options.domain + '/index.php/b?i=' + options.buttonStyle + '&lang=cs' // image only exists in cs

    // if there is no image we replace by a generic
    imageButton.onerror = function() {
        imageButton.src = node.dataset.icon_status
        for (const textButton of node.querySelectorAll('span.status')) {
            textButton.textContent = node.dataset.text_offline
        }
    }
    button.appendChild(imageButton)

    const textButton = document.createElement('span')
    textButton.classList.add('status')
    textButton.textContent = node.dataset.text_online
    button.appendChild(textButton)
    node.appendChild(button)

    button.addEventListener("click", () => {
        Mibew.Objects.ChatPopups[button.dataset.chat_id].open()
        sessionStorage.setItem("mibew_chat_open", "1")
    })

    const extraPath = options.extraUrlPath || ''
    fetch(options.domain + extraPath + "/opstatus").then(response => response.json()).then(result => {
        let text, status
        if (result) {
            text = node.dataset.text_online
            status = "alert-success"
        } else {
            text = node.dataset.text_offline
            status = "alert-danger"
        }
        textButton.textContent = text
        const alert = textButton.closest("div.alert")
        if (alert) {
            [...alert.classList].forEach(className => {
                if (className.startsWith("alert-")) {
                    node.classList.remove(className)
                }
            })
            alert.classList.add(status)
        }
    }).catch(error => console.log(error))
}

function getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
        return parts.pop().split(';').shift()
    }
    return null
}

function setCookie(name, value, days) {
    const maxAge = days ? `; max-age=${days * 24 * 60 * 60}` : ''
    document.cookie = `${name}=${value}${maxAge}; path=/`
}

export const initOnlinechat = () => {
    if (typeof Mibew !== 'undefined') {
        updateMibew()
        const options = collectOptions()
        initChatPopup(options)
        for (const node of document.querySelectorAll('.onlinechat')) {
            initMibewChatAndCreateButton(node, options)
        }
        const popup = Mibew.Objects.ChatPopups && Mibew.Objects.ChatPopups[options.id]
        if (popup) {
            const cookieName = COOKIE_PREFIX + options.id
            if (getCookie(cookieName) === null) {
                setCookie(cookieName, 'true', 1)
            }
            popup.open()
        }
    }
}
